import loadable from '@loadable/component'

export const Breadcrumb = loadable(() => import('./Breadcrumb'))
export type { BreadCrumbProps } from './Breadcrumb'
